<template>
  <div class="mark-container spacex-16">
    <span class="text-sm grey-500">{{ selectedCount }} {{ $t('selected') }}</span>
    <Button size="small" type="ghost" @click="$emit('mark')">
      {{ $t('Mark as read') }}
    </Button>
  </div>
</template>

<script>
  import Button from '@/components/ui/Button';

  export default {
    name: 'MarkAsRead',
    components: {
      Button,
    },
    props: {
      selectedCount: {
        type: Number,
        required: true,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mark-container {
    background: #ffffff;
    box-shadow: 0px 4px 8px rgba(31, 45, 63, 0.03), 0px 8px 32px rgba(31, 45, 63, 0.1);
    border-radius: 8px;

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 16px;

    width: fit-content;

    position: absolute;
    left: 50%;
    margin-left: -100pt;
    bottom: 20px;
  }
</style>
